import { InjectionToken } from '@angular/core';

export const SOFTLINE_MODULE_AI_AGENT = 'ai-agent';
export const SOFTLINE_PERMISSION_AI_AGENT = 'SOFTAPPS.AI_AGENT';

export interface AiAgentModuleConfig {
  /** Base URL of the ai-agent service. Relative = same origin, proxied in dev. */
  apiBaseUrl?: string;
  /** AG-UI agent id addressed by the browser; the service exposes exactly one. */
  agentId?: string;
}

export const DEFAULT_AI_AGENT_CONFIG: Required<AiAgentModuleConfig> = {
  apiBaseUrl: '/ai-agent/api',
  agentId: 'softapps',
};

export const SOFTLINE_CONFIG_AI_AGENT = new InjectionToken<AiAgentModuleConfig>(
  'SOFTLINE_CONFIG_AI_AGENT',
  { factory: () => DEFAULT_AI_AGENT_CONFIG }
);
